"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _warning = _interopRequireDefault(require("warning"));
var _BubbleLoader = _interopRequireDefault(require("./BubbleLoader"));
var _BouncyLoader = _interopRequireDefault(require("./BouncyLoader"));
var _styled = _interopRequireWildcard(require("../styled"));
var _excluded = ["background", "duration", "color", "size", "small", "large", "center", "type"];
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var LoadingWrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: ", ";\n"])), (0, _styled.prop)('background'));
var LoadingIndicator = function LoadingIndicator(_ref) {
  var background = _ref.background,
    duration = _ref.duration,
    color = _ref.color,
    size = _ref.size,
    small = _ref.small,
    large = _ref.large,
    center = _ref.center,
    type = _ref.type,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  (0, _warning.default)(!small, '[LoadingIndicator] `small` is deprecated. Use `size="small"` instead.');
  (0, _warning.default)(!large, '[LoadingIndicator] `large` is deprecated. Use `size="large"` instead.');
  var useType = 'bubble';
  if (type) {
    useType = 'bouncy';
  }
  return /*#__PURE__*/_react.default.createElement(LoadingWrapper, Object.assign({
    background: background
  }, props), useType === 'bubble' && /*#__PURE__*/_react.default.createElement(_BubbleLoader.default, {
    duration: duration,
    color: color,
    center: center,
    size: size || small && 'small' || large && 'large' || null
  }), useType === 'bouncy' && /*#__PURE__*/_react.default.createElement(_BouncyLoader.default, {
    duration: duration,
    color: color,
    center: center,
    size: size || small && 'small' || large && 'large' || null
  }));
};
LoadingIndicator.defaultProps = Object.assign({}, _BubbleLoader.default.defaultProps, {
  background: 'none',
  small: null,
  large: null,
  center: null,
  type: null
});
var _default = exports.default = LoadingIndicator;